import { useEffect, useRef } from "react";

export function SpaceBackground() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!containerRef.current) return;
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      containerRef.current.style.setProperty("--mouse-x", `${x * 12}px`);
      containerRef.current.style.setProperty("--mouse-y", `${y * 12}px`);
    };

    window.addEventListener("mousemove", handleMouseMove, { passive: true });
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div
      ref={containerRef}
      className="fixed inset-0 z-[-2] overflow-hidden"
      style={{
        background: "linear-gradient(180deg, hsl(234 50% 1%) 0%, hsl(232 45% 1.2%) 30%, hsl(230 40% 2%) 60%, hsl(234 45% 1.5%) 100%)",
      }}
    >
      <div
        className="absolute inset-0 opacity-[0.018]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
          backgroundSize: "256px 256px",
        }}
      />

      <div
        className="absolute animate-float-orb"
        style={{
          top: "12%",
          left: "8%",
          width: "380px",
          height: "380px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(59, 130, 246, 0.09) 0%, rgba(59, 130, 246, 0.03) 40%, transparent 70%)",
          filter: "blur(45px)",
          transform: `translate(var(--mouse-x, 0px), var(--mouse-y, 0px))`,
          animationDelay: "0s",
        }}
      />

      <div
        className="absolute animate-float-orb-reverse"
        style={{
          top: "55%",
          right: "5%",
          width: "450px",
          height: "450px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(6, 182, 212, 0.06) 0%, rgba(6, 182, 212, 0.02) 40%, transparent 70%)",
          filter: "blur(55px)",
          transform: `translate(calc(var(--mouse-x, 0px) * -0.6), calc(var(--mouse-y, 0px) * -0.6))`,
          animationDelay: "-5s",
        }}
      />

      <div
        className="absolute animate-float-orb"
        style={{
          top: "35%",
          left: "50%",
          width: "340px",
          height: "340px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(37, 99, 235, 0.05) 0%, rgba(37, 99, 235, 0.015) 40%, transparent 70%)",
          filter: "blur(50px)",
          transform: `translate(calc(var(--mouse-x, 0px) * 0.8), calc(var(--mouse-y, 0px) * 0.8))`,
          animationDelay: "-10s",
        }}
      />

      <div
        className="absolute animate-float-orb-reverse"
        style={{
          bottom: "8%",
          left: "25%",
          width: "420px",
          height: "420px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(37, 99, 235, 0.065) 0%, rgba(37, 99, 235, 0.02) 40%, transparent 70%)",
          filter: "blur(60px)",
          transform: `translate(calc(var(--mouse-x, 0px) * -0.4), calc(var(--mouse-y, 0px) * -0.4))`,
          animationDelay: "-15s",
        }}
      />

      <div
        className="absolute animate-float-orb"
        style={{
          top: "3%",
          right: "20%",
          width: "280px",
          height: "280px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(59, 130, 246, 0.055) 0%, rgba(59, 130, 246, 0.015) 40%, transparent 70%)",
          filter: "blur(38px)",
          transform: `translate(calc(var(--mouse-x, 0px) * 0.5), calc(var(--mouse-y, 0px) * 0.5))`,
          animationDelay: "-8s",
        }}
      />

      <div
        className="absolute animate-float-orb-reverse"
        style={{
          top: "70%",
          right: "50%",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(6, 182, 212, 0.04) 0%, rgba(6, 182, 212, 0.01) 40%, transparent 70%)",
          filter: "blur(48px)",
          transform: `translate(calc(var(--mouse-x, 0px) * 0.7), calc(var(--mouse-y, 0px) * -0.5))`,
          animationDelay: "-12s",
        }}
      />

      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse at 50% 0%, rgba(59, 130, 246, 0.05) 0%, transparent 55%)",
        }}
      />

      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse at center, transparent 30%, rgba(0, 0, 0, 0.65) 100%)",
        }}
      />
    </div>
  );
}
